import { Box, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useTranslation } from "react-i18next";

import { parseStringToDate } from "~/modules/app/util/dateHelpers";
import { formatTimeRange } from "~/modules/app/util/formatters";

type VisitTimeslotSelectorProps = {
    possibleTimeslots: {
        _id: string;
        startTime: string;
        endTime: string;
    }[];
    selectedTimeslotId: string | undefined;
    onChange: (timeslotId: string) => void;
};

export function VisitTimeslotSelector({ possibleTimeslots, selectedTimeslotId, onChange }: VisitTimeslotSelectorProps) {
    const { t } = useTranslation("plannerV2");

    return (
        <Box padding={2}>
            <FormControl fullWidth variant="filled">
                <InputLabel>{t("visitDetail.timeslot")}</InputLabel>
                <Select
                    label={t("visitDetail.timeslot")}
                    value={selectedTimeslotId ?? ""}
                    onChange={event => onChange(event.target.value)}
                >
                    {possibleTimeslots.map(timeslot => (
                        <MenuItem key={timeslot._id} value={timeslot._id}>
                            {formatTimeRange(
                                parseStringToDate(timeslot.startTime),
                                parseStringToDate(timeslot.endTime),
                            )}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>
    );
}
